import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebook,
    faLinkedin,
    faGithub,
    faJira,
    faTwitter,
    faInstagram,
    faYoutube,
    faPinterest,
} from "@fortawesome/free-brands-svg-icons";

import "./footer.css";

export function Footer() {
    const year = new Date().getFullYear();

    const onSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const fd = new FormData(e.currentTarget);
        const email = String(fd.get("email") || "").trim();
        if (!email) return;
        // TODO: Call your API / Email service
        alert(`Thanks! We'll reach out to ${email}`);
        e.currentTarget.reset();
    };

    return (
        <footer className="ytr-footer mt-5">
            {/* Top social strip */}
            <div className="ytr-footer__top">
                <Container className="py-3">
                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                        <div className="ytr-footer__topText">
                            Get connected with us on social networks:
                        </div>

                        <div className="d-flex align-items-center gap-3 ytr-footer__icons">
                            <a
                                href="https://www.facebook.com/YTR-Infotech-362736837426879"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                            >
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>

                            <a
                                href="https://twitter.com/YtrInfotech"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Twitter"
                            >
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>

                            <a href="#" aria-label="Instagram">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>

                            <a href="#" aria-label="YouTube">
                                <FontAwesomeIcon icon={faYoutube} />
                            </a>

                            <a href="#" aria-label="Pinterest">
                                <FontAwesomeIcon icon={faPinterest} />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/ytr-infotech"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="LinkedIn"
                            >
                                <FontAwesomeIcon icon={faLinkedin} />
                            </a>

                            <a
                                href="https://github.com/YTRINFOTECH"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="GitHub"
                            >
                                <FontAwesomeIcon icon={faGithub} />
                            </a>

                            <a
                                href="https://ytrinfotech.atlassian.net/jira/your-work"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Jira"
                            >
                                <FontAwesomeIcon icon={faJira} />
                            </a>
                        </div>
                    </div>
                </Container>
            </div>

            {/* Main footer content */}
            <Container className="py-5">
                {/* CTA / Newsletter */}
                <Row className="g-4 align-items-center mb-4">
                    <Col lg={7}>
                        <div className="ytr-footer__cta">
                            <div className="ytr-footer__ctaTitle">Stay in the loop</div>
                            <div className="ytr-footer__ctaSub">
                                Subscribe for updates on services, hiring, and new offerings.
                            </div>
                        </div>
                    </Col>

                    <Col lg={5}>
                        <Form onSubmit={onSubscribe}>
                            <InputGroup className="ytr-footer__inputGroup">
                                <Form.Control
                                    name="email"
                                    type="email"
                                    placeholder="Enter your email"
                                    aria-label="Email"
                                    className="ytr-footer__input"
                                    required
                                />
                                <Button type="submit" className="ytr-footer__btn">
                                    Subscribe
                                </Button>
                            </InputGroup>
                            <div className="ytr-footer__fineprint mt-2">
                                By subscribing you agree to receive email updates. Unsubscribe anytime.
                            </div>
                        </Form>
                    </Col>
                </Row>

                <hr className="ytr-footer__divider" />

                {/* Modern responsive grid */}
                <Row className="g-4 g-lg-5 mt-1">
                    {/* Get in Touch */}
                    <Col md={6} lg={4}>
                        <div className="ytr-footer__heading">Get in Touch</div>
                        <p className="ytr-footer__text">
                            We are professional IT experts who deal in all kind of IT outsourcing
                            and Software Development.
                        </p>

                        <div className="ytr-footer__miniTitle">USA</div>
                        <div className="ytr-footer__text">
                            1300 W WALNUT HILL LN, STE 158B, IRVING, TX, 75038
                        </div>
                        <div className="ytr-footer__text">Main Line: +1 (612) 998 0375</div>
                        <div className="ytr-footer__text">
                            Email:{" "}
                            <a className="ytr-footer__link" href="mailto:hr@ytrinfotech.com">
                                hr@ytrinfotech.com
                            </a>
                        </div>
                    </Col>

                    {/* About */}
                    <Col md={6} lg={4}>
                        <div className="ytr-footer__heading">YTR Infotech</div>
                        <p className="ytr-footer__text">
                            YTR Infotech Corporation is the fastest growing IT services company.
                            Its incorporated in 2006. Our Headquarter is located at Bloomington,
                            Illinois, United States of America. YTR Infotech aims to be the most
                            preferred Business Partner of all Technology Providers and IT companies globally.
                        </p>

                        <div className="ytr-footer__badge">
                            Innovating IT Solutions Since 2006
                        </div>
                    </Col>

                    {/* Link columns */}
                    <Col lg={4}>
                        <Row className="g-4">
                            <Col xs={6}>
                                <div className="ytr-footer__heading">Industries</div>
                                <ul className="ytr-footer__list">
                                    <li><a className="ytr-footer__link" href="/industries/banking">Banking</a></li>
                                    <li><a className="ytr-footer__link" href="/industries/insurance">Insurance</a></li>
                                    <li><a className="ytr-footer__link" href="/industries/retail">Retail</a></li>
                                    <li><a className="ytr-footer__link" href="/industries/telecom">Telecomm</a></li>
                                    <li><a className="ytr-footer__link" href="/industries/health-care">Health Care</a></li>
                                    <li><a className="ytr-footer__link" href="/industries/automobile">Auto Mobile</a></li>
                                </ul>
                            </Col>

                            <Col xs={6}>
                                <div className="ytr-footer__heading">Our Services</div>
                                <ul className="ytr-footer__list">
                                    <li>
                                        <a className="ytr-footer__link" href="/services/staffing-solutions">
                                            Staffing Solutions
                                        </a>
                                    </li>
                                    <li>
                                        <a className="ytr-footer__link" href="/services/software-services">
                                            Software Services
                                        </a>
                                    </li>
                                    <li>
                                        <a className="ytr-footer__link" href="/services/customer-services">
                                            Customer Services
                                        </a>
                                    </li>
                                    <li>
                                        <a className="ytr-footer__link" href="/services/hr-payroll-solutions">
                                            HR & Payroll Solutions
                                        </a>
                                    </li>
                                </ul>

                                <div className="ytr-footer__heading mt-4">Terms</div>
                                <ul className="ytr-footer__list">
                                    <li>
                                        <a className="ytr-footer__link" href="/privacy-policy">
                                            Privacy Policy
                                        </a>
                                    </li>
                                    <li>
                                        <a className="ytr-footer__link" href="/disclaimer">
                                            Disclaimer
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            {/* Bottom bar */}
            <div className="ytr-footer__bottom">
                <Container className="py-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                    <div className="ytr-footer__bottomText">© {year} YTR Infotech. All Rights Reserved.</div>
                    <div className="ytr-footer__bottomText">
                        Leading IT Services & Consulting Company based in Dallas, Tx, USA, 75038.
                    </div>
                </Container>
            </div>
        </footer>
    );
}
